import React, { useState } from "react";
import "../styles/contact-button.scss";
import { WeuiArrowFilled } from "../components/emoji/arrow";
import ContactForm from "../components/ContactForm";

export const ContactButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    document.body.style.overflow = "unset";
  };

  return (
    <>
      <div className="contact-button">
        <button className="wavy-button" onClick={handleOpenModal}>
          contact me
          <WeuiArrowFilled />
        </button>
      </div>
      {isModalOpen && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={handleCloseModal}>
              ×
            </button>
            <div className="modal-body">
              <h1>contact me</h1>
              <ContactForm />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
